export default "/kiban/_next/static/images/bottom_green-c0454e750d90ba60f03b9ea419ed96c7.png";